import React from "react";
import { NavLink } from "react-router-dom";
import { MdEventNote, MdOutlineSms } from 'react-icons/md'
import { FiBarChart2, FiDatabase, FiLogOut, FiImage } from 'react-icons/fi'
import { RiDashboard3Line } from 'react-icons/ri'
import Logo from '../../assets/images/logo/Haylo-for-white-background.png'
import LocalStorage from "../../hook/LocalStorage";
import { isTwoWaySmsEnabled } from "../../pages/SmsBilling/smsAccess";
import { useGalleryAccess } from '../../pages/SocialGalleryV2/GalleryAccess';
const formatUnreadCount = (count) => Number(count) > 99 ? "99+" : Number(count);

const Sidebar = ({ toggleLayoutSidebar, unreadConversationCount = 0 }) => {
  const { user } = LocalStorage();
  const { enabled: galleryEnabled } = useGalleryAccess();
  const displayName = (user ? `${user.first_name || ''} ${user.last_name || ''}`.trim() : '') || 'Haylo member';
  const initials = displayName.split(' ').filter(Boolean).slice(0, 2).map((part) => part.charAt(0).toUpperCase()).join('');

  // Toggle Start
  const sidebarAction = () => {
    toggleLayoutSidebar(false);
  };

  const logout = () => {
    localStorage.removeItem("token_verify");
    localStorage.removeItem("users");
    window.location.assign("/");
  };

  return (
    <>
      <aside className="sidebar-wrapper">
        <div className="sidebar-header">
          <div className="mb-0 logo">
            <img src={Logo} className="img-fluid" alt="logo" />
          </div>

          <NavLink to="#" onClick={sidebarAction} className="ml-auto toggle-btn" activeClassName="mm-active">
            <i className="bx bx-menu" />{" "}
          </NavLink>
        </div>

        <div className="sidebar-navigation">
        <ul className="metismenu" id="menu">
          <li className="active-menu">
            <NavLink to="/dashboard" activeClassName="mm-active">
              <div className="parent-icon "><RiDashboard3Line /></div>
              <div className="menu-title">Dashboard</div>
            </NavLink>
          </li>
          <li className="active-menu ">
            <NavLink to="/event#live" activeClassName="mm-active">
              <div className="parent-icon "><MdEventNote /></div>
              <div className="menu-title">Events</div>
            </NavLink>
          </li>
          <li className="active-menu ">
            <NavLink to="/data-capture" activeClassName="mm-active">
              <div className="parent-icon "><FiDatabase /></div>
              <div className="menu-title">Data Management</div>
            </NavLink>
          </li>
          {galleryEnabled && <li className="active-menu">
            <NavLink to="/social-gallery/settings" activeClassName="mm-active" isActive={(_, location) => location.pathname.startsWith('/social-gallery/')}>
              <div className="parent-icon"><FiImage /></div>
              <div className="menu-title">Social Gallery 2.0</div>
            </NavLink>
          </li>}
          {isTwoWaySmsEnabled(user) ? (
            <li className="active-menu ">
              <NavLink to="/conversions" activeClassName="mm-active">
                <div className="parent-icon "><MdOutlineSms /></div>
                <div className="menu-title sidebar-menu-title">
                  <span>Revenue Loops</span>
                  {unreadConversationCount > 0 ? (
                    <span className="sidebar-conversation-badge">
                      {formatUnreadCount(unreadConversationCount)}
                    </span>
                  ) : null}
                </div>
              </NavLink>
            </li>
          ) : null}
          {isTwoWaySmsEnabled(user) ? (
            <li className="active-menu ">
              <NavLink to="/roi-reports" activeClassName="mm-active">
                <div className="parent-icon "><FiBarChart2 /></div>
                <div className="menu-title">ROI Reports</div>
              </NavLink>
            </li>
          ) : null}
        </ul>
        </div>
        <button type="button" className="sidebar-logout-button" onClick={logout} title="Log out">
          <FiLogOut />
          <span>Log out</span>
        </button>
        <NavLink to="/profile" className="sidebar-user-card" activeClassName="is-active">
          <span className="sidebar-user-avatar">{initials || 'HC'}</span>
          <span className="sidebar-user-copy"><strong>{displayName}</strong><small>Venue Admin</small></span>
          <span className="sidebar-user-chevron">⌄</span>
        </NavLink>
      </aside>
    </>
  );
};

export default Sidebar;
